import React from 'react';
import { usePlan } from '@features/onboarding/hooks/usePlan';
import { useFinalSubmissionStore } from 'src/store/final-submission';
import { cn } from '@utils/index';

interface PlansSummaryGridProps {
  contributionAmount: number;
  contributionLabel?: string;
  isChangePlan?: boolean;
}

export const PlansSummaryTable: React.FC<PlansSummaryGridProps> = ({
  contributionAmount,
  contributionLabel = 'NGA contribution',
  isChangePlan
}) => {
  const { plans, totalPlanPrice, handleChangePlan, handleRemovePlan } = usePlan();
  const { underwritingResult } = useFinalSubmissionStore();

  const sortedPlans = [...plans].sort((a, b) => {
    const isARejected = a.baseKey === 'majormedical' && underwritingResult?.status === 'rejected';
    const isBRejected = b.baseKey === 'majormedical' && underwritingResult?.status === 'rejected';

    if (isARejected && !isBRejected) return 1;
    if (!isARejected && isBRejected) return -1;
    return 0;
  });

  console.log('plans', plans);

  return (
    <div className="mt-10.5 text-sm">
      <div className="hidden md:grid md:[grid-template-columns:100px_1.5fr_1.8fr_120px] gap-x-6 font-medium border-b pb-2">
        <p className="font-bold">Insurer</p>
        <p className="font-bold">Plan Name</p>
        <p className="font-bold">Actions</p>
        <div className="text-right font-bold">Monthly Premium</div>
      </div>

      {sortedPlans.map((plan, idx) => (
        <div
          key={idx}
          className={cn(
            "border-b py-3 grid md:[grid-template-columns:100px_1.5fr_2fr_120px] gap-x-6 items-start",
            plan.baseKey === "majormedical" && underwritingResult?.status === 'rejected' && 'finish-plan-disabled'
          )}
        >
          <div className="hidden md:block">{plan.insurer}</div>
          <div className="hidden md:block font-extrabold">
            {plan.name}
          </div>
          <div className="hidden md:flex md:justify-between w-[85%] 4xl:w-[90%] 6xl:w-[70%] font-semibold whitespace-nowrap ml-2">
            {!(plan.baseKey === "majormedical" && underwritingResult?.status === 'rejected') && <>
              <button
                onClick={() => handleChangePlan(plan)}
                className="text-denary mr-4 hover:text-primary text-[12px] transition font-extrabold cursor-pointer"
              >
                Change Plan
              </button>
              <button
                onClick={() => handleRemovePlan(plan)}
                className="text-error hover:text-primary text-[12px] transition font-extrabold cursor-pointer"
              >
                Remove Plan
              </button>
            </>}
          </div>
          <div className="hidden md:block text-right">
            {
              plan.baseKey === "majormedical" && underwritingResult?.status === 'rejected' ? 
                '$00.00' :
                <>${plan.price.toFixed(2)}</>
            }
          </div>

          <div className="md:hidden flex flex-col space-y-4">
            <div>
              <span className="font-bold !font-secondary">Insurer: </span>
              {plan.insurer}
            </div>
            <div>
              <span className="font-bold !font-secondary">Plan Name: </span>
              <span className="font-extrabold !font-secondary">
                {plan.name}
              </span>
            </div>
            <div>
              <span className="font-bold !font-secondary">Actions: </span>
              <span className="text-error font-semibold inline-flex space-x-4 ml-4">
                <button
                  onClick={() => handleChangePlan(plan)}
                  className="text-[12px] font-extrabold hover:text-primary transition !font-secondary"
                >
                  Change Plan
                </button>
                <button
                  onClick={() => handleRemovePlan(plan)}
                  className="text-[12px] font-extrabold hover:text-primary transition !font-secondary"
                >
                  Remove Plan
                </button>
              </span>
            </div>
            <div className="pt-1 flex justify-between">
              <span className="font-bold !font-secondary">
                Monthly Premium{' '}
              </span>
              <span>${plan.price.toFixed(2)}</span>
            </div>
          </div>
        </div>
      ))}

      <div className="ml-auto max-w-[280px]">
        <div className="flex justify-between items-center py-3 border-b">
          <div className="text-right font-semibold !font-secondary">
            Subtotal
          </div>
          <div className="text-right !font-secondary">
            ${totalPlanPrice.toFixed(2)}
          </div>
        </div>
        {/* NGA contribution показывается только если есть вклад */}
        {contributionAmount !== 0 && (
          <div className="flex justify-between items-center py-3 border-b">
            <div className="text-right font-semibold !font-secondary">
              {contributionLabel}
            </div>
            <div className="text-right text-error font-semibold !font-secondary">
              {contributionAmount.toFixed(2)}
            </div>
          </div>
        )}
        <div className="flex justify-between items-center py-3 border-b">
          <div className="col-span-3 text-right font-extrabold !font-secondary">
            Your Monthly Total
          </div>
          <div className="text-right font-extrabold !font-secondary">
            ${totalPlanPrice.toFixed(2)}
          </div>
        </div>
      </div>
      {isChangePlan && <div className="flex flex-col px-7 py-6 bg-[#f4f3f3] mt-16 w-fit rounded-2xl">
        <p className="font-black text-base w-fit">
          Wait—Why Did My Health Plan Price Change?
        </p>
        <p className="lg:max-w-[82%] w-fit mt-2">
          The price you first saw for youe medial plans was an average—now that
          we have your health questionnaire answers, we’ve updated it to reflect
          your actual rate. If you'd like to explore other options, no
          problem—every plan shown now includes your personalized pricing.
        </p>
      </div>}
    </div>
  );
};
